import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export type FaIconProps = SvgIconProps;

const createFaIcon = (def: IconDefinition) => {
  const width = def.icon[0];
  const height = def.icon[1];
  const pathPropsList = (Array.isArray(def.icon[4]) ? def.icon[4] : [def.icon[4]])
    .map((d, index) => ({
      d,
      key: `${def.iconName}_path_${index}`,
    }));

  const Component = React.memo(
    React.forwardRef<SVGSVGElement, FaIconProps>(
      ({ children, ...svgProps }, ref) => (
        <SvgIcon viewBox={`0 0 ${width} ${height}`} {...svgProps} ref={ref}>
          {
            pathPropsList.map((pathProps) => <path {...pathProps} fill="currentColor" />)
          }
          {children}
        </SvgIcon>
      ),
    ),
  );

  if (process.env.NODE_ENV !== 'production') {
    Component.displayName = `${def.prefix.charAt(0).toUpperCase() + def.prefix.slice(1)}-${def.iconName}-icon`
      .replace(/(-\w)/g, ([, match]) => match.toUpperCase());
  }

  return Component;
};

export default createFaIcon;
